import _ from 'lodash'

import { connect } from 'react-redux'

import Chart, { IChartProps } from './Chart'
import { IChartPoint, IState, } from './types'

// tslint:disable-next-line
// MEMORY MONITOR (KB): com.mersive.solstice.server=236076,com.mersive.solstice.server:monitorservice=8971,com.splashtop.m360.mersive=12200,com.mersive.keystoreinitializer=3974,time=1538779487549,total=2997172,free=2321491,used=493944
export const memoryKeys: string[] = [
  // 'total',
  // 'free',
  // 'used',
  'com.mersive.solstice.server',
  // 'com.splashtop.m360.mersive',
  // 'com.mersive.solstice.server:monitorservice',
  // 'com.mersive.keystoreinitializer',
]

const mapStateToProps = (state: IState): IChartProps => {
  const data: IChartPoint[] = _
    .chain(state.chartPoints)
    .filter((point: IChartPoint) => point.chartType === 'MEMORY')
    .sortBy('timestamp')
    .value()

  return {
    data,
    keys: memoryKeys,
  }
}

export default connect(mapStateToProps)(Chart)



// WEBPACK FOOTER //
// ./src/Memory.tsx